import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, accountNumber, apiKey] as const

export type geljCredType = (typeof credentialTypes)[number]
export const geljDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const gelj: CarrierDef<geljCredType> = {
  name: 'GlobalTranz',
  scac: 'gelj',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['account-number', 'accountNumber'],
  ],
  engineLayers: ['rating', 'bol', 'pickup', 'tracking', 'documents'],
  documentTypes: geljDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
